import { useTranslation } from 'react-i18next';
import { constants } from '../../constants';

export default function ViewCreatorsButton() {
  const [t] = useTranslation(['chatroom']);

  return (
    <button
      className="py-2 w-full border-2 border-solid border-[#38539A] rounded-3xl text-sm text-[#38539A] bg-white"
      onClick={() => {
        window.location.assign(constants.creatorsHome);
      }}
    >
      {t('view_creators', '查看創玩+營隊素材')}
    </button>
  );
}
